import EventDelete from './EventDelete';

export default EventDelete;
